import { Component, OnInit, Inject } from '@angular/core';
import { MantenimientosService } from 'src/app/core/services/mantenimientos.service';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { Regimenes } from 'src/app/core/models/regimenes';

@Component({
  selector: 'app-edicion-regimen',
  templateUrl: './edicion-regimen.component.html',
  styleUrls: ['./edicion-regimen.component.scss']
})
export class EdicionRegimenComponent implements OnInit {

  listRegimenes:Regimenes[]=[];
  isChecked:boolean=false;
  Estado:string;
  existError:boolean=false;
  mensajeError:string;

  constructor(private miservicio:MantenimientosService,
    public thisDialogRef: MatDialogRef<MatDialog>, @Inject(MAT_DIALOG_DATA) public data:Regimenes) { }

  ngOnInit() {
    this.listarDatos();
  }

  listarDatos(){
    this.miservicio.getRegimenes(this.data.intId).subscribe(datos=>{
      this.listRegimenes=datos;
      //console.log(this.listRegimenes);
      if(this.listRegimenes[0].strActivo==='S'){
        this.isChecked=true;
        this.Estado='Activa'
      }else{
        this.isChecked=false;
        this.Estado='Inactiva'
      }
    })
  }

  pulsa(){
    if(this.isChecked===true){
      this.Estado='Inactiva';
    }else{
      this.Estado="Activa";
    }
  }

  salvar(e){
    let miEstado:string;

    if(this.isChecked===true){
      miEstado='S';
    }else{
      miEstado="N";
    }

    // console.log(e);
    // console.log(miEstado)

    this.miservicio.putRegimen(e,miEstado).subscribe((datos:any)=>{
      //console.log(datos);
      if(datos.miRespuesta.booOk){
        this.thisDialogRef.close(datos.miListRegimenes);
      }else{
        this.mensajeError=datos.miRespuesta.strMensaje;
        this.existError=true;
      }
    })
  }

  cancelar(){
    this.thisDialogRef.close();
  }

}
